import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { OnboardingCredential } from '../onboarding.model';
import { onboardingservice } from '../onboarding.service';

@Component({
  selector: 'app-onboarding-register',
  templateUrl: './onboarding-register.component.html',
  styleUrls: ['./onboarding-register.component.scss']
})
export class OnboardingRegisterComponent implements OnInit {
  @Output() newItemEvent = new EventEmitter<string>();
  page: string = 'register'
  verified: boolean = false;
  LoginForm: FormGroup;
  constructor(private formBuilder: FormBuilder, public router: Router, public global: GlobalComponent, public toastrService: ToastrService, public RegisterhttpService: onboardingservice) {
    this.LoginForm = this.formBuilder.group({
      Email: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      Confirm_password: ['', [Validators.required]],
    }, { validator: matchingPasswords('password', 'Confirm_password') });
  }
  private onDestroy$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
  }

  Create: OnboardingCredential = new OnboardingCredential();
  registered: any
  RegisterDetails() {
    this.Create.agencyId = this.Create.agencyId;
    this.Create.agencyId = this.global.globalAgencyId
    this.RegisterhttpService.registerJobPortal(this.Create).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        this.registered = data
        this.toastrService.success('Your registration was successful! please login')
        this.page = 'login';
        this.newItemEvent.emit(this.page);
      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err.error, 'Error'), 8000;
      }
    })
  }

  MoveToNextPage(page: string) {
    this.page = page;
    this.newItemEvent.emit(this.page);
  }

  register() {
    var data;
    if (this.global.LoginTypeFields == 'employee') {
      localStorage.setItem("CFSS_login", JSON.stringify(data));
      this.router.navigate(['/employee-onboarding']);

    }
    else {
      localStorage.setItem("CFSS_login", JSON.stringify(data));
      this.router.navigate(['/client-onboarding']);
    }
  }

  public onSubmit(values: Object): void {
    if (this.LoginForm.valid) {
      //  this.router.navigate(['/onboarding/client/'+this.global.agencyCode], );
      this.page = 'login';
      this.newItemEvent.emit(this.page);
    }
  }
  cancel() {
    this.page = 'login';
    this.newItemEvent.emit(this.page);
  }
}
export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
  return (group: FormGroup) => {
    let password = group.controls[passwordKey];
    let passwordConfirmation = group.controls[passwordConfirmationKey];
    if (password.value !== passwordConfirmation.value) {
      return passwordConfirmation.setErrors({ mismatchedPasswords: true })
    }
  }
}

